import { StoreState } from '@/redux/types';

export const selectAssortmentCategoryPath = (state: StoreState) =>
  state.productTypes.assortment.categoryPath;
